import { useState } from 'react';

import { Autocomplete } from '@packages/fenrir/components/autocomplete';
import { OutlinedInput } from '@packages/fenrir/components/outlined-input';

/* -------------------------------------------------------------------------------------------------
 * MultiSelectFilterInput
 * -----------------------------------------------------------------------------------------------*/
export type MultiSelectOption = {
  value: string;
  label: string;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const MultiSelectFilterInput = (props: Record<string, any>) => {
  const { item, applyValue, options } = props;

  const [selectedOptions, setSelectedOptions] = useState<MultiSelectOption[]>(
    item.value || [],
  );

  const handleChange = (
    _event: React.SyntheticEvent,
    newValue: MultiSelectOption[],
  ) => {
    setSelectedOptions(newValue);
    applyValue({ ...item, value: newValue });
  };

  const isOptionEqualToValue = (
    option: MultiSelectOption,
    value: MultiSelectOption,
  ) => {
    return option.value === value.value;
  };

  return (
    <Autocomplete
      multiple
      options={options}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={isOptionEqualToValue}
      value={selectedOptions}
      onChange={handleChange}
      sx={{ display: 'flex' }}
      renderInput={(params) => (
        <OutlinedInput
          {...params.InputProps}
          inputProps={{
            ...params.inputProps,
            id: `multi-select-filter-input-${item.field}`,
          }}
          placeholder="Filter value"
          sx={{ width: '100%' }}
        />
      )}
    />
  );
};
